import { BaseAPI } from './BaseAPI.js'
import { LicenseType } from '../types/index.js'

export default class LicenseTypesAPI extends BaseAPI<LicenseType> {
  override get resource(): string {
    return '/licenseTypes'
  }
}
